import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import '../styles/ProjectMB91.css'

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KranIcon from '../website_images/Icons/kran.png'
import HausIcon from '../website_images/Icons/haus.png'
import GrundrissIcon from '../website_images/Icons/grundriss.png'
import ParkenIcon from '../website_images/Icons/parken.png'
import ScrollAnimation from '../components/ScrollAnimation';

const ProjectMB91: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="container project-mb91">
            <section className="project-mb91-header page-hero" id="page-hero" />
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div id="team">
                        <h2>{t('projectMB91Header')}</h2>
                        <h1>{t('projectMB91Title')}</h1>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('projectMB91Description')) }}>
                        </p>
                    </div>
                </ScrollAnimation>
            </section>

            <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className="projectmb91-slider-section" id="brand">
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={KranIcon} alt="Kran icon" className='icons' />
                                    <h2>{t('constructionStartMB91')}</h2>
                                </div>
                                <span>{t('constructionStartDateMB91')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={HausIcon} alt="Haus icon" className='icons' />
                                    <h2>{t('completionMB91')}</h2>
                                </div>
                                <span>{t('completionDateMB91')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={GrundrissIcon} alt="Grundriss icon" className='icons' />
                                    <h2>{t('residentialUnitsMB91')}</h2>
                                </div>
                                <span>{t('residentialUnitsDetailsMB91')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={ParkenIcon} alt="Parken icon" className='icons' />
                                    <h2>{t('parkingSpacesMB91')}</h2>
                                </div>
                                <span>{t('parkingSpacesDetailsMB91')}</span>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </section>

            <section className="main-section">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div className='projectmb91-highlights'>
                        <h1>{t('projectHighlightsMB91')}</h1>
                        <ul>
                            <li>{t('projectMB91Highlight1')}</li>
                            <li>{t('projectMB91Highlight2')}</li>
                            <li>{t('projectMB91Highlight3')}</li>
                            <li>{t('projectMB91Highlight4')}</li>
                        </ul>
                    </div>
                </ScrollAnimation>
            </section>

            {/** <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className='projectmb91-section'>
                            <h1>{t('integratedRealEstateKnowhow')}</h1>
                            <h2>{t('strongGroupSystem')}</h2>
                            <p>{t('integratedRealEstateDescription')}</p>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className="contact-button-section company-contact">
                        <Link to='/unternehmen' className="contact-button">
                            {t('discoverCompanies')}
                        </Link>
                    </div>
                    </ScrollAnimation>
                    
                </div>
            </section>*/}
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div>
                        <h1>{t('projectInterestTitleMB91')}</h1>
                        <h2>{t('projectInterestDescriptionMB91')}</h2>
                        <div className="contact-button-section">
                            <Link to='/kontakt' className="knowhow-button-section projectmb91-button">{t('requestProjectProfile')}</Link>
                        </div>
                    </div>

                </ScrollAnimation>
            </section>
        </div>
    );
};

export default ProjectMB91;
